/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import Card from "../../../../components/Cards/Card";
import { twoFactorMap } from "../../../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../../../utils/services/remittance.service";

function Body({ domainBrand, remittanceValues, passwordPolicies }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const ipObject = twoFactorMap(dictionary).map((i) => {
    if (i.name === "enableTwoFactorSms") {
      i = { ...i, value: remittanceValues?.enableTwoFactorSms };
    }
    if (i.name === "enableTwoFactorEmailStaffOnly") {
      i = { ...i, value: remittanceValues?.enableTwoFactorEmailStaffOnly };
    }
    if (i.name === "enableTwoFactorEmailCustomerOnly") {
      i = { ...i, value: remittanceValues?.enableTwoFactorEmailCustomerOnly };
    }
    return { ...i };
  });

  const [open] = useState(false);
  const [ipWhitelist, setIpWhiteList] = useState(false);
  const [twoFactor, setTwoFactor] = useState(false);
  const [enableSca, setEnableSca] = useState(false);
  const [enablePin, setEnablePin] = useState(false);
  const [transactionPIn, setTransactionPin] = useState(false);

  const [twoFactorObject, setTwoFactorObject] = useState([...ipObject]);

  const [ipAddress, setIpAddress] = useState("");
  const [payload, setPayload] = useState({});
  const [loading, setLoading] = useState(false);

  const resetIp = async (payload) => {
    setLoading(true);
    try {
      const response = await RemittanceService.ipWhiteListSetting(payload);
      if (response.data.status === "SUCCESS") {
        toast.success("ip address updated successfully.");
        setIpAddress("");
        setLoading(false);
      } else {
        toast.success(response.data.message);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const onChange = (e) => {
    const temp = twoFactorObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setTwoFactorObject([...temp]);
    setPayload({ ...payload, [e.target.name]: e.target.checked });
  };

  const resetEnableTwoFactor = async (payload) => {
    setLoading(true);
    try {
      const response = await RemittanceService.twoFactorAuthSetting(payload);
      if (response.data.status === "SUCCESS") {
        toast.success("two factor auth settings updated successfully.");
        setPayload({});
        setLoading(false);
      } else {
        toast.success(response.data.message);
        setPayload({});
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const resetScaAndTransactionPin = async (payload) => {
    setLoading(true);
    try {
      const response = await RemittanceService.transactionPinAndScaSetting(
        payload
      );
      if (response.data.status === "SUCCESS") {
        toast.success("settings updated successfully.");
        setPayload({});
        setLoading(false);
      } else {
        toast.success(response.data.message);
        setPayload({});
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary ? dictionary["m_security"] : "Security"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <Card>
              <ul className="list-group mb-2">
                {/* IP WHITE LIST */}
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setIpWhiteList(!ipWhitelist)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {ipWhitelist ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_IP_ADDRESS_RESTRICTI_-421114094"]
                    : "IP whitelisting"}
                </li>
                <Collapse in={ipWhitelist}>
                  <div id="example-collapse-text" className="px-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_IP_WHITELISTING_ALLO_361092514"]
                        : `IP whitelisting allows you to create lists of trusted IP addresses or IP ranges from which your STAFF can access your domains. IP whitelist is a security feature often used for limiting and controlling access only to trusted STAFF.`}
                    </label>
                    <div className="form-row py-4">
                      <label>
                        {dictionary
                          ? dictionary["WO_RESTRICT_STAFF_ACCES_978120862"]
                          : `Restrict staff access to the IP addresses [ Add more than 1 IP address with coma separation. eg: 178.62.71.55, 198.42.81.55]. This will not effect customers.`}
                      </label>

                      <input
                        type={"text"}
                        className="form-control"
                        defaultValue={remittanceValues?.ipaddressRestriction}
                        onChange={(e) => setIpAddress(e.target.value)}
                      />
                    </div>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            const payload = {
                              ipWhitelisted: ipAddress,
                            };
                            resetIp(payload);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${
                              dictionary
                                ? dictionary["WO_UPDAT_-774819892"]
                                : "Update"
                            }`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>

            <Card>
              <ul className="list-group mb-2">
                {/* ENABLE 2 FA */}
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setTwoFactor(!twoFactor)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {twoFactor ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_FACTOR_VIA_-1132787956"]
                    : "Enable 2-factor"}
                </li>
                <Collapse in={twoFactor}>
                  <div id="example-collapse-text" className="px-3">
                    <label>
                      {dictionary
                        ? dictionary["WO_ENABLE_FACTOR_VIA_-1132787956"]
                        : `Enable 2-factor`}
                    </label>

                    <div className="form-row py-4">
                      {twoFactorObject?.map((i, idx) => {
                        return (
                          <div className="col-md-6 col-lg-6" key={idx + 1}>
                            <div className="py-3">
                              <input
                                type={"checkbox"}
                                className="check-box"
                                onChange={(e) => onChange(e)}
                                defaultChecked={i.value}
                                id={i.name}
                                name={i.name}
                              />
                              <span className="ps-2 align-top">{i.title}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => resetEnableTwoFactor(payload)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${
                              dictionary
                                ? dictionary["WO_UPDAT_-774819892"]
                                : "Update"
                            }`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>

            <Card>
              <ul className="list-group mb-2">
                {/* ENABLE SCA */}
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setEnableSca(!enableSca)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {enableSca ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_STRONG_CUSTOM_-1835724157"]
                    : "Enable Strong Customer Authentication"}
                </li>
                <Collapse in={enableSca}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      <div className="col-md-6 col-lg-6">
                        <div className="py-3">
                          <input
                            type={"checkbox"}
                            className="check-box"
                            id={"isStrongCustomerAuthenticationEnabled"}
                            name={"isStrongCustomerAuthenticationEnabled"}
                            onChange={onChange}
                            defaultChecked={
                              remittanceValues?.isStrongCustomerAuthenticationEnabled
                            }
                          />
                          <span className="ps-2 align-top">
                            {dictionary
                              ? dictionary[
                                  "WO_ENABLE_STRONG_CUSTOM_-1835724157"
                                ]
                              : "Enable Strong Customer Authentication"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            resetScaAndTransactionPin(payload);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${
                              dictionary
                                ? dictionary["WO_UPDAT_-774819892"]
                                : "Update"
                            }`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>

            <Card>
              <ul className="list-group mb-2">
                {/* ENABLE TRANSACTION PIN */}
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setEnablePin(!enablePin)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {enablePin ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_TRANSACTION_P_-236007065"]
                    : "Enable Transaction pin Authentication"}
                </li>
                <Collapse in={enablePin}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      <div className="col-md-6 col-lg-6">
                        <div className="py-3">
                          <input
                            type={"checkbox"}
                            className="check-box"
                            id={"enableTransactionPin"}
                            name={"enableTransactionPin"}
                            defaultChecked={
                              remittanceValues?.enableTransactionPin
                            }
                            onChange={onChange}
                          />
                          <span className="ps-2 align-top">
                            {dictionary
                              ? dictionary["WO_ENABLE_TRANSACTION_P_1460895606"]
                              : "Enable Transaction pin"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            resetScaAndTransactionPin(payload);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${
                              dictionary
                                ? dictionary["WO_UPDAT_-774819892"]
                                : "Update"
                            }`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
